import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../redux';
import { validateToken } from '../api/auth';
import { useEffect, useRef } from 'react';
import { useSocket } from '../socket';

// note: need these extra checks because when page first loads,
//       the reducer hasn't finished loading yet
export const useUsername = () => {
    // return useSelector((state) => state.game?.player?.name || '');
    return useSelector((state) => state.username || "");
};

export const useIsLoggedIn = () => {
    return useSelector((state) => state.loggedIn || false);
};

export const useIsPlayingAsGuest = () => {
    return useSelector((state) => state.playingAsGuest || false);
};

export const useIsAuthLoading = () => {
    return useSelector((state) => state.isAuthLoading || false);
};

export const useUserRole = () => {
    return useSelector((state) => state.userRole || 'user');
};

export const useAuthState = () => {
    const dispatch = useDispatch();
    const socket = useSocket();
    // Stores credentials so the reconnect handler can re-authenticate without re-reading Redux
    const credentialsRef = useRef(null);

    useEffect(() => {
        const token = localStorage.getItem("authToken");

        const doAuth = async () => {
            if (token) {
                dispatch(actions.setIsAuthLoading(true));
                const user = await validateToken(token);
                if (user) {
                    dispatch(actions.logIn(user.username));
                    if (user.elo != null) dispatch(actions.updatePlayerRating(user.elo));
                    if (user.role) dispatch(actions.setUserRole(user.role));
                    credentialsRef.current = { type: 'user', playerId: user.username, token };
                    socket.emit("authenticate", { playerId: user.username, token });
                    socket.emit("rejoin", { playerId: user.username, token });
                } else {
                    localStorage.removeItem("authToken");
                    dispatch(actions.logOut());
                    // Token was invalid (e.g. deleted account) — fall back to any saved guest session
                    const guestId = localStorage.getItem('guestPlayerId');
                    if (guestId) {
                        dispatch(actions.playAsGuest(guestId));
                        credentialsRef.current = { type: 'guest', playerId: guestId };
                        socket.emit("authenticate", { playerId: guestId });
                        socket.emit("rejoin", { playerId: guestId });
                    }
                }
                dispatch(actions.setIsAuthLoading(false));
            } else {
                // No auth token — check if a guest session was saved from a previous page load
                const guestPlayerId = localStorage.getItem('guestPlayerId');
                if (guestPlayerId) {
                    dispatch(actions.playAsGuest(guestPlayerId));
                    credentialsRef.current = { type: 'guest', playerId: guestPlayerId };
                    socket.emit("authenticate", { playerId: guestPlayerId });
                    socket.emit("rejoin", { playerId: guestPlayerId });
                }
                dispatch(actions.setIsAuthLoading(false));
            }
        };

        doAuth();

        // Re-authenticate when Socket.IO reconnects after a network drop.
        // The server forgets the socket's player identity on disconnect, so we
        // must re-send these events to restore the in-game session.
        const handleReconnect = () => {
            const creds = credentialsRef.current;
            if (!creds) return;
            if (creds.type === 'user') {
                socket.emit("authenticate", { playerId: creds.playerId, token: creds.token });
                socket.emit("rejoin", { playerId: creds.playerId, token: creds.token });
            } else {
                socket.emit("authenticate", { playerId: creds.playerId });
                socket.emit("rejoin", { playerId: creds.playerId });
            }
        };

        socket.on('connect', handleReconnect);
        return () => socket.off('connect', handleReconnect);
    }, [dispatch, socket]);
};

// import { useState } from "react";
// import { useDispatch } from "react-redux";
// import { actions } from "../redux";

// export const useAuth = () => {
//     const dispatch = useDispatch();
//     // const [user, setUser] = useState(() => {
//     //     try {
//     //         return JSON.parse(localStorage.getItem("user")) || null;
//     //     } catch {
//     //         localStorage.removeItem("user"); // clear bad data
//     //         return null;
//     //     }
//     // });

//     const login = (userData) => {
//         if (userData) {
//             console.log(`setting user data in local storage: ${userData}`);
//             localStorage.setItem("user", JSON.stringify(userData));
//             // setUser(userData);

//             dispatch(actions.setUsername(userData.username));
//         } else {
//             // If userData is null or undefined, clear storage and state
//             console.log("null user data, so we remove stored user...");
//             localStorage.removeItem("user");
//             // setUser(null);
//         }
//     };

//     const logout = () => {
//         localStorage.removeItem("user");
//         // setUser(null);
//     };

//     return { login, logout };
// };
